import type { SVGProps } from "react";
// generated from CloseFull.svg — do not edit manually
// prettier-ignore
export default function CloseFull(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 19 5 L 5 19 M 5 5 L 19 19" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
